import { useAppSplash } from '@context'
import React from 'react'
import styled from 'styled-components'
import AppSplash from './AppSplash'

export const GlobalSplashOverlay: React.FC = () => {
  const { isVisible, activeSource } = useAppSplash()

  return (
    <Overlay
      data-testid="global-splash-overlay"
      data-source={activeSource}
      $isVisible={isVisible}
      aria-hidden={!isVisible}
    >
      <AppSplash />
    </Overlay>
  )
}

const Overlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  z-index: 9999;
`

export default GlobalSplashOverlay
